import { httpsCallable,  } from 'firebase/functions'
import { functions } from "../firebase";

export default class API {


    // -------------- User End Points -------------


    static async getAdminUsers(access_token){
        return await httpsCallable( functions,  'api/get_admin_users')({
            access_token: access_token
        });
    }

    static async updateUsersIsAdmin(access_token, user_id, is_admin){
        return await httpsCallable( functions,  'api/update_user_is_admin')({
            access_token: access_token,
            user_id: user_id,
            is_admin: is_admin
        });
    }

    static async createNewUser(access_token, email){
        return await httpsCallable( functions,  'api/create_new_user')({
            access_token: access_token,
            email: email.trim().toLowerCase()
        });
    }

    // ----------------------------------------

    static async syncZohoEnquiries(){
        return await httpsCallable( functions,  'api/sync_zoho_enquiries')({
        });
    }

    static async sendConfidentialEnquiry(enquiry_form_id, klaviyo_profile_id){
        return await httpsCallable( functions,  'api/send_confidential_enquiry')({
            enquiry_form_id: enquiry_form_id,
            klaviyo_profile_id: klaviyo_profile_id
        });
    }


    static async getKlaviyoLists(){
        return await httpsCallable( functions,  'api/get_klaviyo_lists')({});
    }

    static async getPageAtPath(path) {
        return await httpsCallable( functions, 'api/fetch_page')({ path: path });
    }

    static async updateUserPermissions(payload = {}) {
        return await httpsCallable(functions, 'api/update_user_permissions')({
            ...payload
        })
    }

    static async sendNotification(type, match){
        return await httpsCallable( functions,  'api/send_notification')({
            type: type,
            match: match
        });
    }

    static async sendNotificationTest(){
        return await httpsCallable( functions,  'api/send_notification_test')({});
    }
}